import { networkStatusFor } from 'actions/network/actions'
import config from 'config'
import { LocationChangeAction } from 'connected-react-router'
import { call, put, takeLatest } from 'redux-saga/effects'
import { IFirebaseResponse } from 'types/IFirebaseResponse'
import { NetworkError } from 'types/networkError'
import { storeReaderAnswers } from './actions'

function getAllReaderAnswers(): Promise<IFirebaseResponse> {
  return window.fetch('populisten-quiz-2019.json').then(response => {
    if (response.ok) {
      return response.json()
    }
    throw new NetworkError(response.statusText, response.status)
  })
}

function* downloadFromFirebase() {
  yield put(networkStatusFor('download')('loading'))

  try {
    const results = yield call(getAllReaderAnswers)    
    yield put(storeReaderAnswers(results as IFirebaseResponse))
    yield put(networkStatusFor('download')('success'))
  } catch (e) {
    if (e instanceof NetworkError) {
      yield put(networkStatusFor('download')(e.status))
    }
    throw e
  }
}

export function* watchForDownload() {
  // @ts-ignore
  yield takeLatest<LocationChangeAction>(
    action =>
      action.type === '@@router/LOCATION_CHANGE' &&
      action.payload.location.pathname === '/results',
    downloadFromFirebase
  )
}
